import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  coursesDone: {
    id: 'progress.coursesDone',
    defaultMessage: 'Courses Done',
    description: 'Label for completed courses stat',
  },
  ongoingCourses: {
    id: 'progress.ongoingCourses',
    defaultMessage: 'Ongoing Courses',
    description: 'Label for ongoing courses stat',
  },
  totalCourses: {
    id: 'progress.totalCourses',
    defaultMessage: 'Total Courses',
    description: 'Label for total courses stat',
  },
  certificatesObtained: {
    id: 'progress.certificatesObtained',
    defaultMessage: 'Certificates Obtained',
    description: 'Label for certificates obtained stat',
  },
  badgesEarnedRecently: {
    id: 'progress.badgesEarnedRecently',
    defaultMessage: 'Badges Earned Recently',
    description: 'Title for recent badges card',
  },
  viewAll: {
    id: 'progress.viewAll',
    defaultMessage: 'View All',
    description: 'View all link text',
  },
  ongoingCoursesTitle: {
    id: 'progress.ongoingCoursesTitle',
    defaultMessage: 'Ongoing Courses',
    description: 'Title for ongoing courses section',
  },
  course: {
    id: 'progress.course',
    defaultMessage: 'Course',
    description: 'Table header for course column',
  },
  progress: {
    id: 'progress.progress',
    defaultMessage: 'Progress',
    description: 'Table header for progress column',
  },
  action: {
    id: 'progress.action',
    defaultMessage: 'Action',
    description: 'Table header for action column',
  },
  viewCertificate: {
    id: 'progress.viewCertificate',
    defaultMessage: 'View Certificate',
    description: 'Link to view course certificate',
  },
  certificateExpired: {
    id: 'progress.certificateExpired',
    defaultMessage: 'Certificate expired',
    description: 'Badge shown when a course certificate has passed its expiry date',
  },
  certificateExpires: {
    id: 'progress.certificateExpires',
    defaultMessage: 'Certificate expires {date}',
    description: 'Label showing when a course certificate will expire',
  },
  viewProgress: {
    id: 'progress.viewProgress',
    defaultMessage: 'View Progress',
    description: 'Dropdown item that links to the course progress page',
  },
  moreOptions: {
    id: 'progress.moreOptions',
    defaultMessage: 'More options',
    description: 'Accessible label for the row actions dropdown toggle',
  },
  learningActivityMap: {
    id: 'progress.learningActivityMap',
    defaultMessage: 'Learning Activity Map',
    description: 'Title for activity map section',
  },
  viewDetailedMap: {
    id: 'progress.viewDetailedMap',
    defaultMessage: 'View Detailed Map',
    description: 'Link to view detailed activity map',
  },
  lastMonthActivity: {
    id: 'progress.lastMonthActivity',
    defaultMessage: 'Last month activity',
    description: 'Subtitle for activity map',
  },
  detailedMap: {
    id: 'progress.detailedMap',
    defaultMessage: 'Detailed Map',
    description: 'Title for the detailed activity map page',
  },
  back: {
    id: 'progress.back',
    defaultMessage: 'Back',
    description: 'Back button label',
  },
  goBack: {
    id: 'progress.goBack',
    defaultMessage: 'Go Back',
    description: 'Go Back button label on the ongoing courses listing page',
  },
  searchCoursesPlaceholder: {
    id: 'progress.searchCoursesPlaceholder',
    defaultMessage: 'Search Courses...',
    description: 'Placeholder for the search input on the ongoing courses listing page',
  },
  filter: {
    id: 'progress.filter',
    defaultMessage: 'Filter',
    description: 'Label for the filter button on the ongoing courses listing page',
  },
  filterByProgress: {
    id: 'progress.filterByProgress',
    defaultMessage: 'Filter by progress',
    description: 'Heading for the progress-filter dropdown on the ongoing courses listing page',
  },
  filterAll: {
    id: 'progress.filterAll',
    defaultMessage: 'All courses',
    description: 'Progress filter option to show all ongoing courses',
  },
  filterNotStarted: {
    id: 'progress.filterNotStarted',
    defaultMessage: 'Not started',
    description: 'Progress filter option for courses with 0% progress',
  },
  filterInProgress: {
    id: 'progress.filterInProgress',
    defaultMessage: 'In progress',
    description: 'Progress filter option for courses with partial progress',
  },
  filterCompleted: {
    id: 'progress.filterCompleted',
    defaultMessage: 'Completed',
    description: 'Progress filter option for courses with 100% progress',
  },
  loadingCourses: {
    id: 'progress.loadingCourses',
    defaultMessage: 'Loading courses',
    description: 'Screen reader text shown while the ongoing courses list is loading',
  },
  paginationLabel: {
    id: 'progress.paginationLabel',
    defaultMessage: 'Ongoing courses pagination',
    description: 'Accessible label for the ongoing courses pagination control',
  },
  lastYearActivity: {
    id: 'progress.lastYearActivity',
    defaultMessage: 'Last year activity',
    description: 'Subtitle for year activity map',
  },
  mostActiveDays: {
    id: 'progress.mostActiveDays',
    defaultMessage: 'Most Active Days',
    description: 'Title for most active days card',
  },
  monthlySummary: {
    id: 'progress.monthlySummary',
    defaultMessage: 'Monthly Summary',
    description: 'Title for monthly summary card',
  },
  current: {
    id: 'progress.current',
    defaultMessage: 'Current',
    description: 'Badge for current month',
  },
  units: {
    id: 'progress.units',
    defaultMessage: '{count} Units',
    description: 'Units count label',
  },
  less: {
    id: 'progress.less',
    defaultMessage: 'LESS',
    description: 'Heatmap legend less label',
  },
  more: {
    id: 'progress.more',
    defaultMessage: 'MORE',
    description: 'Heatmap legend more label',
  },
  activeDays: {
    id: 'progress.activeDays',
    defaultMessage: 'ACTIVE DAYS',
    description: 'Monthly summary popover active days label',
  },
  unitsCompleted: {
    id: 'progress.unitsCompleted',
    defaultMessage: 'UNITS COMPLETED',
    description: 'Monthly summary popover units completed label',
  },
  improvementBy: {
    id: 'progress.improvementBy',
    defaultMessage: 'Improvement by {percent}% from last month',
    description: 'Monthly summary improvement badge',
  },
  declineBy: {
    id: 'progress.declineBy',
    defaultMessage: 'Decline by {percent}% from last month',
    description: 'Monthly summary decline badge',
  },
  emptyStateAlert: {
    id: 'progress.emptyStateAlert',
    defaultMessage: 'Your progress appears here as you complete courses and earn certificates.',
    description: 'Info alert shown on the progress page for learners with no enrollments',
  },
  emptyStateAlertClose: {
    id: 'progress.emptyStateAlertClose',
    defaultMessage: 'Dismiss',
    description: 'Accessible label for the close button on the empty-state alert',
  },
  exploreCoursesTitle: {
    id: 'progress.getStarted.exploreCoursesTitle',
    defaultMessage: 'Browse the course library',
    description: 'Title of the get-started card that links to the discover page',
  },
  exploreCoursesBody: {
    id: 'progress.getStarted.exploreCoursesBody',
    defaultMessage: 'Find courses your organisation has prepared for your learning journey.',
    description: 'Body copy of the get-started card that links to the discover page',
  },
  askAiTutorTitle: {
    id: 'progress.getStarted.askAiTutorTitle',
    defaultMessage: 'Ask the AI tutor',
    description: 'Title of the get-started card that opens the AI chat',
  },
  askAiTutorBody: {
    id: 'progress.getStarted.askAiTutorBody',
    defaultMessage: 'Describe what you want to learn and get a personalised course recommendation.',
    description: 'Body copy of the get-started card that opens the AI chat',
  },
  viewScheduleTitle: {
    id: 'progress.getStarted.viewScheduleTitle',
    defaultMessage: 'View your schedule',
    description: 'Title of the get-started card that links to upcoming sessions',
  },
  viewScheduleBody: {
    id: 'progress.getStarted.viewScheduleBody',
    defaultMessage: 'See upcoming deadlines, live sessions, and any training assigned to you.',
    description: 'Body copy of the get-started card that links to upcoming sessions',
  },
  teamActivityTitle: {
    id: 'progress.getStarted.teamActivityTitle',
    defaultMessage: "See your team's activity",
    description: 'Title of the get-started card shown to learners who belong to a team',
  },
  teamActivityBody: {
    id: 'progress.getStarted.teamActivityBody',
    defaultMessage: 'Catch up on what your teammates are learning right now.',
    description: 'Body copy of the get-started card shown to learners who belong to a team',
  },
  exploreTopicTitle: {
    id: 'progress.getStarted.exploreTopicTitle',
    defaultMessage: 'Explore by topic',
    description: 'Title of the fallback get-started card that links to discover by topic',
  },
  exploreTopicBody: {
    id: 'progress.getStarted.exploreTopicBody',
    defaultMessage: 'Browse popular topics and pick a direction for your first course.',
    description: 'Body copy of the fallback get-started card that links to discover by topic',
  },
  comingSoonBadge: {
    id: 'progress.getStarted.comingSoonBadge',
    defaultMessage: 'Coming soon',
    description: 'Badge label shown on the team-activity card until the feature is available',
  },
});

export default messages;
